import { AsyncLocalStorage } from 'async_hooks';
import { Injectable } from '@nestjs/common';

export const DEFAULT_STORE_ID = 'store_demo';
export const DEFAULT_ORGANIZATION_ID = 'org_demo';

export interface StoreContext {
  storeId: string;
  organizationId: string;
  domain?: string;
  // false whenever we fell back to the default store instead of matching a
  // real, active store — required (not optional) so a new resolution path
  // can't silently skip deciding this.
  resolved: boolean;
}

@Injectable()
export class StoreContextService {
  private readonly storage = new AsyncLocalStorage<StoreContext>();

  run<T>(context: StoreContext, callback: () => T): T {
    return this.storage.run(context, callback);
  }

  current(): StoreContext {
    return (
      this.storage.getStore() ?? {
        storeId: DEFAULT_STORE_ID,
        organizationId: DEFAULT_ORGANIZATION_ID,
        resolved: false,
      }
    );
  }

  storeId(): string {
    return this.current().storeId;
  }

  organizationId(): string {
    return this.current().organizationId;
  }

  resolved(): boolean {
    return this.current().resolved;
  }
}
